import React from 'react'
import { motion } from 'framer-motion'
import styles from './Question.module.css'
import classNames from 'classnames'

const calculateLines = (string, limit) =>
  string
    ?.split(/\s+/)
    .reduce(
      (acc, word) =>
        acc[acc.length - 1].length + word.length < limit
          ? [
              ...acc.slice(0, acc.length - 1),
              acc[acc.length - 1] + `${acc[acc.length - 1] ? ' ' : ''}${word}`,
            ]
          : [...acc, word],
      ['']
    )

function Question({ large, title, questionImgUrl, questionFontSize }) {
  const LIMIT_LENGHT = 210 / Number(questionFontSize)
  let lines = calculateLines(title, LIMIT_LENGHT)
  let isLong = false
  let currLimit = LIMIT_LENGHT
  let recalculationIterations = 0

  while (lines.length > 3) {
    isLong = true
    currLimit += 15
    lines = calculateLines(title, currLimit)
    recalculationIterations++
  }

  return (
    <motion.div
      className={classNames(styles.block, {
        [styles.large]: large,
      })}
      initial={{ y: 1000, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1 }}
      key={title}
    >
      <div
        className={classNames(
          styles[questionImgUrl ? 'question' : 'question-noImg'],
          {
            [styles.large]: large,
          }
        )}
      >
        <div className={classNames(styles.title, { [styles.large]: large })}>
          {lines?.map((line, i) => (
            <motion.div
              key={line}
              initial={{ y: 1000, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 2, delay: i * 0.5 }}
            >
              <span
                style={{
                  fontSize: `${
                    isLong
                      ? questionFontSize * (1 - 0.2 * recalculationIterations)
                      : questionFontSize
                  }rem`,
                }}
              >
                {line}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.div>
  )
}

export default Question
